import "./LoadingScreen.scss";

function LoadingScreen(props) {
  return (
    <>
      <div className="loading_screen">
        <div className="loading_screen__2077">{props.currentYear}</div>
        <img
          className="loading_screen__spinning_title"
          src="/assets/loadingTitle.png"
          alt="spinningTitle"
        />
        <img
          className="loading_screen__line-left"
          src={"/assets/loadingLine.png"}
          alt="Left Line"
        />
        <img
          className="loading_screen__line-right"
          src={"/assets/loadingLine.png"}
          alt="Right Line"
        />
      </div>
      <img
        className="loading_screen__background-right"
        src="/assets/loadingMobileRightElement.svg"
        alt="Back Right"
      ></img>
      {/*<img
        className="loading_screen__background-left"
        src="/assets/loadingMobileLeftElement.svg"
        alt="Back Left"
      ></img>*/}
      <img
        className="loading_screen__badge-right"
        src="/assets/loadingMobileRightBadge.svg"
        alt="Badge Left"
      ></img>
      <img
        className="loading_screen__badge-left"
        src="/assets/loadingMobileLeftBadge.svg"
        alt="Badge Right"
      ></img>
    </>
  );
}

export default LoadingScreen;
